/**
 * jQuery plugin unwidow
 * verbindet die letzten beiden Worte im HTML-Inhalt eines Elements mit einem geschützten Leerzeichen
 * EXAMPLE: $('.shop-start-advantages-item-headline').unwidow();
 */
(function( $ ) {

    $.fn.unwidow = function() {

    	this.each(function() {

    		var modifiedContent = $(this).html().replace(/(\S+)\s+(\S+\s*$)/, '$1' + '&nbsp;' + '$2');
		    $(this).html(modifiedContent);

	    });

        return this;

    };

}( jQuery ));





/* ----- navigation / offcanvas navigation -------------------------------------------------------------------------- */

// adjust body paddingTop
function _adjustOffcanvasLayer () { // adjusts top but also closes the offcanvas layer

	var layer = $('.offcanvas-collapse'),
		toggler = $('.navbar-toggler'),
		header = $('.page-header-container'),
		headerHeight = Math.floor(header.height());

	layer.css('top', headerHeight);
	layer.removeClass('show collapse');
	toggler.addClass('collapsed');
	// $('body').css('paddingTop', headerHeight);

	// layer.css('height', $(window).height() - headerHeight ); // make the layer the height of the visible area, so scrolling does work
	//console.log('_adjustOffcanvasLayer');

}

$(function() {

	// close layer when browser window is resized or otherwise altered
	/*
	$(window).on('orientationchange resize', function (e) {

		// close all submenus in offcanvas layer
		closeNavSubmenus();

		// adjust top and close the offcanvas layer
 		_adjustOffcanvasLayer();

	});
	*/

	// initialize content top
	_adjustOffcanvasLayer();

	// close search layer when nav toggler is clicked
	$('.navbar-toggler').on('click', headerSearchFieldClose);

});





$(function() {

	/*
	$('.shop-header-main-nav-item .headline').matchHeight({
	    byRow: false,
	    property: 'height',
	    target: null,
	    remove: false
	});
	*/

	$('.page-cb-news-3-item').matchHeight();
	$('.page-cb-news-3-items-headline-2').matchHeight();
	$('.page-cb-news-3-items-text').matchHeight();
	$('.page-product-category-bg').matchHeight();

	$('.page-cb-gridblocks-item-headline').matchHeight();
	$('.page-cb-gridblocks-item-inner').matchHeight();

});










/* ------ initialize responsive bootstrap toolkit ------------------------------------------------------------------- */

(function ($, viewport) {

	// take care of bs4 compatibility
	var visibilityDivs = {
		'xxs': $('<div class="d-block d-xs-none"></div>'),
		'xs': $('<div class="d-none d-xs-block d-sm-none"></div>'),
		'sm': $('<div class="d-none d-sm-block d-md-none"></div>'),
		'md': $('<div class="d-none d-md-block d-lg-none"></div>'),
		'lg': $('<div class="d-none d-lg-block d-xl-none"></div>'),
		'xl': $('<div class="d-none d-xl-block"></div>'),
	};
	viewport.use('custom', visibilityDivs);

	var doOnWindowResize = function () {

		// console.log('Current breakpoint: ', viewport.current());

		// header nav search field
		if (viewport.is('<=md')) {

			// header nav search field is hidden -> open
			// attach event handler just once
			$('.page-nav-search-submit').off('click', doOnSearchButtonClick).one('click', doOnSearchButtonClick);


        } else {

			$('.page-nav-search-submit').off('click', doOnSearchButtonClick);

		}


		// offcanvas navigation
		if (viewport.is('<=md')) {

			$('.dropdown').off('mouseenter mouseleave', toggleDropdown);

			// open active submenus in offcanvas layer
			openNavSubmenus();

		} else { // matches also tablets/iPads

			$('.dropdown').off('mouseenter mouseleave', toggleDropdown).on('mouseenter mouseleave', toggleDropdown);

		}

	};

	$(function() {

		// on resize
		$(window).resize(
			viewport.changed(function () {
				doOnWindowResize();
			})
		).resize();
		window.rbtViewport = viewport;

	});

})(jQuery, ResponsiveBootstrapToolkit);






// ----- page header nav search ----------------------------------------------------------------------------------------

function doOnSearchButtonClick (e) {

	e.preventDefault();

	_adjustOffcanvasLayer();
	_closeSearchResultsLayer();

	var form = $(this).closest('form'),
		wrapper = form.find('input').parent(), // .page-nav-search-input-wrapper
		submit = form.find('button[type="submit"]'), // which one?
		openClass = 'open';

	if (wrapper.hasClass(openClass)) {
		wrapper.slideUp('fast').removeClass(openClass);
	} else {
		wrapper.slideDown('fast').addClass(openClass);
	}

	// re-attach event handler (again just once), if viewport width is <= md
	if (ResponsiveBootstrapToolkit.is('<=md')) {
		submit.off('click', doOnSearchButtonClick).one('click', doOnSearchButtonClick);
	}

}

function headerSearchFieldClose () {

	var headerSearchComponentClass = 'page-nav-search',
		wrapper = $('.' + headerSearchComponentClass).find('div[class*="wrapper"]').eq(0),
		openClass = 'open';

	wrapper.slideUp('fast').removeClass(openClass);

}

function headerSearchFieldOpen () {

	var headerSearchComponentClass = 'page-nav-search',
		wrapper = $('.' + headerSearchComponentClass).find('div[class*="wrapper"]').eq(0),
		openClass = 'open';

	wrapper.slideDown('fast').addClass(openClass);

}

$(function(){

	// search button arrow
	$('.page-nav-search-button').on('click', function(e) {

		e.preventDefault();
		$(this).closest('form').submit();

	});

});



// ----- polyfill object-fit-images ------------------------------------------------------------------------------------

$(function(){

	// polyfill Polyfill object-fit/object-position on <img>: IE9, IE10, IE11, Edge, Safari, ... https://github.com/fregante/object-fit-images
	objectFitImages('img.page-cb-teaser-large-image');
	objectFitImages('img.page-cb-news-3-items-image');

});









// ---------------------------------------------------------------------------------------------------------------------
// dropdown on hover
/*
var subnavShowClass = 'show';
$('ul.level-1 > li.dropdown').on('mouseenter', function () {
	self = $(this);
	self.addClass(subnavShowClass);
	self.find('ul.dropdown-menu').addClass(subnavShowClass);
}).on('mouseleave', function () {
	self = $(this);
	self.removeClass(subnavShowClass);
	self.find('ul.dropdown-menu').removeClass(subnavShowClass);
});
*/

// version for mouse / hover over submenu parent items
function toggleDropdown(e) {
	const _d = $(e.target).closest('.dropdown'), // li.dropdown
		  _m = $('.dropdown-menu', _d); // li.dropdown > ul.dropdown-menu
	setTimeout(function () {
		const shouldOpen = e.type !== 'click' && _d.is(':hover');
		_m.toggleClass('show', shouldOpen);
		_d.toggleClass('show', shouldOpen);
		$('[data-toggle="dropdown"]', _d).attr('aria-expanded', shouldOpen);
	}, e.type === 'mouseleave' ? 300 : 0);
}

// version for submenu toggle button clicks in offcanvas layer
function toggleDropdownOffcanvas(e) {
	const _d = $(e.target).closest('.dropdown'), // li.dropdown
		  _m = $('.dropdown-menu', _d); // li.dropdown > ul.dropdown-menu
	setTimeout(function () {
		const shouldOpen = e.type === 'click' && !_d.hasClass('show');
		_m.toggleClass('show', shouldOpen);
		_d.toggleClass('show', shouldOpen);
		$('[data-toggle="dropdown"]', _d).attr('aria-expanded', shouldOpen);
	}, e.type === 'mouseleave' ? 300 : 0);
}

// if menuitems with submenuitems were clicked
/*
function doOnDropDownToggleClicked(e) {
	e.preventDefault();
	document.location.href = $(this).attr('href');
}
*/

// open active submenus in offcanvas layer
function openNavSubmenus() {
	$('.dropdown.active').each(function () {
		var _d = $(this),
			_m = _d.find('.dropdown-menu');
		_m.addClass('show');
		_d.addClass('show');
		$('[data-toggle="dropdown"]', _d).attr('aria-expanded', true);
	});
}

// close all submenus in offcanvas layer
function closeNavSubmenus() {
	$('.dropdown').each(function(){
		var _d = $(this),
			_m = _d.find('.dropdown-menu');
		_m.removeClass('show');
		_d.removeClass('show');
		$('[data-toggle="dropdown"]', _d).attr('aria-expanded', false);
	});
}

// ---------------------------------------------------------------------------------------------------------------------
// offcanvas / submenu stuff
$(function() {

	// on mobile: prevent submenu from closing, when a submenuitem was clicked
	$('.dropdown-menu, .dropdown-toggle').on('click', function (e) {
		// e.preventDefault();
		e.stopPropagation();
		$('body').on('hide.bs.dropdown', function (e) {
			e.preventDefault();
			e.stopPropagation();
			return false;
		});
	});

	// handle subnav toggle button clicks
	$('.page-submenu-toggle-btn').on('click', toggleDropdownOffcanvas);

	/*
	// let click on submenu parent open the target
	// $('a.dropdown-toggle').one('click', doOnDropDownToggleClicked);
	*/

});

// ---------------------------------------------------------------------------------------------------------------------

// lazyloading for img.lazy
// note: picturefill is also installed!
$(function(){

	var lazyLoadInstance = new LazyLoad({
        elements_selector: '.lazy'
        // ... more custom settings?
	});

	// e.g. after ajax calls:
	// lazyLoadInstance.update();



	// <picture> fallback for IE11
	var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
	if (isIE11) {
		$('picture').each(function () {
			var picture = $(this),
				noscript = picture.find('noscript');
			if (noscript.length) { // if has fallback picture element for ie11
				picture.parent().append($(noscript.text()));
				picture.remove();
			}
		})
	}
	// / Fallback for IE11

});

// ---------------------------------------------------------------------------------------------------------------------

$(function(){
	if ("ontouchstart" in document.documentElement) {
		// do nothing
	} else {
		$('html').addClass('is-not-touch-device');
	}
	if (typeof (IS_TOUCH_DEVICE) !== 'undefined' && IS_TOUCH_DEVICE) {
		$('html').addClass('is-touch-device');
	}
});

// ---------------------------------------------------------------------------------------------------------------------

/* // moved to new, more accurare resize handler below
// workaround for matchheight's inability to respond to browser window maximization and minimization
$(function(){
	$(window).on('resize', function () {
		setTimeout(function () {
			$.fn.matchHeight._update();
		}, 300);
	});
});
*/

// ---------------------------------------------------------------------------------------------------------------------

$(function(){

	function fixNavBehaviour() {
		// make drop-downs work properly with touchscreens by preventing instant hover-click
		var mainNavigationItemSelector = '#page-nav-main-wrapper > .level-1 > .nav-item';
		$(mainNavigationItemSelector).each(function () {
			var li = $(this);
			if (li.find('a').length > 1) { // if this nav item contains more than one link, which means it has a submenu
				li.on('mouseover', function () { // touch device triggers mouseover on tap
					// console.log('mouseover');
					// store time of hover event
					li.data('hoverTime', new Date().getTime());
				});
				li.children('.page-nav-link').on('click', function () { // some touch devices also trigger click on tap
					if ( window.rbtViewport.is('>=lg') ) { // only fix desktop navigation on touch devices
						// console.log('click');
						// only allow click if at least 50ms has elapsed since hover
						// console.log( new Date().getTime() - li.data('hoverTime') );
						return (new Date().getTime() - li.data('hoverTime')) > 50;
					}
				});
			}
		});
	}
	if (window.IS_TOUCH_DEVICE) { // only fix touch devices // @see footer.php
		fixNavBehaviour();
	}
});

// ---------------------------------------------------------------------------------------------------------------------



// ---------------------------------------------------------------------------------------------------------------------
// add body scroll lock

function pageBodyScrollLock () { // == mobile menu opens

	// body scroll lock
	$('body').data('page-scroll-y', window.scrollY);
	document.body.style.width = '100%';
	document.body.style.position = 'fixed';

}

function pageBodyScrollUnlock () { // mobile menu closes

	// body scroll lock
	document.body.style.position = '';
	document.body.style.top = '';
	$(window).scrollTo($('body').data('page-scroll-y') || 0);

}

$(function() {

	$('#page-nav-main-wrapper').on('hidden.bs.collapse', function () {
		console.log('closed');
		pageBodyScrollUnlock();
	})
	$('#page-nav-main-wrapper').on('shown.bs.collapse', function () {
		console.log('opened');
		pageBodyScrollLock();
	})

	/* // moved to new more accurate resize event below
	$(window).on('resize', function () {
		// adjust - but don't close - offcanvas layer
		var layer = $('.offcanvas-collapse'),
			header = $('.page-header-container'),
			headerHeight = Math.floor(header.height());
		layer.css('top', headerHeight);
	});
	*/



	// -----------------------------------------------------------------------------------------------------------------
	// differentiate between resize and scroll in ios safari
	// @see: https://stackoverflow.com/questions/8898412/iphone-ipad-triggering-unexpected-resize-events

    // Store the window width
    var windowWidth = $(window).width();

    // Resize Event
    $(window).on('resize', function () {

        // Check window width has actually changed and it's not just iOS triggering a resize event on scroll
        if ($(window).width() != windowWidth) {

            // Update the window width for next time
            windowWidth = $(window).width();

            // Do stuff here

	        // ---------------------------------------------------------------------------------------------------------
			// workaround for matchheight's inability to respond to browser window maximization and minimization
			setTimeout(function () {
				$.fn.matchHeight._update();
			}, 300);

	        // ---------------------------------------------------------------------------------------------------------
	        // adjust - but don't close - offcanvas layer
			var layer = $('.offcanvas-collapse'),
				header = $('.page-header-container'),
				headerHeight = Math.floor(header.height());
			layer.css('top', headerHeight);

			// ---------------------------------------------------------------------------------------------------------
	        // close offcanvas layer when viewport is getting wider
			if (window.rbtViewport.is('<=md')) { // <= 991
				// do not close offcanvas layer
			} else { // >= 992
				// close all submenus in offcanvas layer
				closeNavSubmenus();
				// adjust top and close the offcanvas layer
				_adjustOffcanvasLayer();
				// remove body scroll lock
				pageBodyScrollUnlock();
			}
			// ---------------------------------------------------------------------------------------------------------

        }

        // Otherwise do nothing

    });
	// -----------------------------------------------------------------------------------------------------------------

});



// ---------------------------------------------------------------------------------------------------------------------
// startpage

$(function(){
	if ($('html.page-home').length) {
		var contact_block = $('.page-cb-contact'),
			contact_icon = contact_block.find('.page-cb-contact-icon'),
			contact_link = contact_block.find('.page-cb-contact-text a').eq(0).get(0);
		contact_icon.css('cursor','pointer');
		contact_block.on('click', contact_icon, function () {
			contact_link.click();
		});
	}
});

// ---------------------------------------------------------------------------------------------------------------------